import PropTypes from "prop-types";

import { DragDropContext } from "react-beautiful-dnd";
import { Draggable } from "./draggable";
import { Droppable } from "./droppable";

export function DragDrop({ children, onDragEnd }: any) {
  return <DragDropContext onDragEnd={onDragEnd}>{children}</DragDropContext>;
}

DragDrop.Droppable = Droppable;
DragDrop.Draggable = Draggable;

DragDrop.propTypes = {
  children: PropTypes.any,
  onDragEnd: PropTypes.func,
};
